// extracted by mini-css-extract-plugin
export default {"container":"FilterFeatureVideoLesson_container__L-PqA","groupLabel":"FilterFeatureVideoLesson_groupLabel__gxCId"};